import React from 'react';
import styled from 'styled-components';

import { ServiceGroup } from '@/types/serviceGroup';
import { useExtractLinksFromService } from '@/components/pages/Service/Detail/shared/hooks/useExtractLinks';

import { LPLink } from '../../../shared/Presentation/LPLink';
import { ServiceGroupDescription } from '../../../shared/Presentation/ServiceGroupDescription';
import { SubHeader } from '../../../shared/Presentation/SubHeader';
import { SubscriptionListRootContainer } from '../../SubscriptionListRoot';

import { isDisplaySubscriptionList } from '../util';
import { SERVICE_GROUP_ID } from '@/constants';
import { Actions } from './Actions';
import { AdminLinks } from './AdminLinks';
import { EmbaServiceEndingAnnouncement } from './embaServiceEndingAnnouncement';

type Props = {
  children?: never;
  service: ServiceGroup;
  showMemberWarning: boolean;
  isManager: boolean;
};

export const NONGLS: React.FC<Props> = (props) => {
  const { service, showMemberWarning, isManager } = props;

  const links = useExtractLinksFromService(service);
  const lpLinkUrl = links.landingPage?.url || '';
  return (
    <>
      <SubHeader service={service} />
      <HorizontalWrapper>
        <Left>
          <EmbaServiceEndingAnnouncement service={service} />
          <ServiceGroupDescription>
            {service.description}
          </ServiceGroupDescription>
          {lpLinkUrl && <LPLink url={lpLinkUrl} />}
          <AdminLinks links={links.admin} serviceGroupId={service.id} />
        </Left>
        <Right>
          {/* 新規申込ボタン */}
          {service.id === SERVICE_GROUP_ID.emba && (
            <Actions
              subscribeUrl={links.subscribe}
              showMemberWarning={showMemberWarning}
            />
          )}
        </Right>
      </HorizontalWrapper>
      {isManager && isDisplaySubscriptionList(service.id) && (
        <SubscriptionListRootContainer serviceGroupID={service.id} />
      )}
    </>
  );
};

const HorizontalWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 934px;
`;

const Left = styled.div`
  flex: 1;
  margin-right: 4em;
  min-width: 350px;
`;

const Right = styled.div`
  margin-left: auto;
  width: 339px;
`;
